import { render, staticRenderFns } from "./MultiStepQuizDialog.vue?vue&type=template&id=d4591596&scoped=true&"
import script from "./MultiStepQuizDialog.vue?vue&type=script&lang=js&"
export * from "./MultiStepQuizDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepQuizDialog.vue?vue&type=style&index=0&id=d4591596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4591596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
